export const BestandView3Headers = [
    {
        id: 1,
        title: 'Firma Kurz',
        mouseOver: '',
    },
    {
        id: 2,
        title: 'Firma',
        mouseOver: '',
    },
    {
        id: 3,
        title: 'MA',
        mouseOver: '',
    },
    {
        id: 4,
        title: 'Zust. FKB',
        mouseOver: '',
    },
    {
        id: 5,
        title: 'KBD',
        mouseOver: '',
    },
    {
        id: 6,
        title: 'KFD',
        mouseOver: '',
    },
    {
        id: 7,
        title: 'DGAPI KAM',
        mouseOver: '',
    },
    {
        id: 8,
        title: 'Überl. R+V',
        mouseOver: 'Überl. R+V',
    },
    {
        id: 9,
        title: 'Ersttermin',
        mouseOver: 'Ersttermin',
    },
    {
        id: 10,
        title: 'Analyseb vollst',
        mouseOver: 'Analysebogen vollständig',
    },
    {
        id: 11,
        title: 'SK-Termin',
        mouseOver: 'SK-Termin',
    },
    {
        id: 12,
        title: 'iForm Termin',
        mouseOver: 'iForm Entscheidungs-Termin',
    },
    {
        id: 13,
        title: 'iForm DGAPI-AM',
        mouseOver: 'iForm an DGAPI-AM',
    },
    {
        id: 14,
        title: 'Auftrag DL-Paket',
        mouseOver: 'Auftrag an AMS zum DL-Paket',
    },
    {
        id: 15,
        title: 'Bemerk',
        mouseOver: 'Bemerkung'
    },
]

export const BestandView3HeadersDgg = [
    {
        id: 1,
        title: 'Firma Kurz',
        mouseOver: '',
    },
    {
        id: 2,
        title: 'Firma',
        mouseOver: '',
    },
    {
        id: 3,
        title: 'MA',
        mouseOver: '',
    },
    {
        id: 4,
        title: 'Zust. CL',
        mouseOver: '',
    },
    {
        id: 5,
        title: 'ADM',
        mouseOver: '',
    },
    {
        id: 6,
        title: 'KGSL',
        mouseOver: '',
    },
    {
        id: 7,
        title: 'DG KAM',
        mouseOver: '',
    },
    {
        id: 8,
        title: 'Übrl. Vertr.',
        mouseOver: 'Übrl. Vertr.',
    },
    {
        id: 9,
        title: 'Ersttermin',
        mouseOver: 'Ersttermin',
    },
    {
        id: 10,
        title: 'Analyseb vollst',
        mouseOver: 'Analysebogen vollständig',
    },
    {
        id: 11,
        title: 'SK-Termin',
        mouseOver: 'SK-Termin',
    },
    {
        id: 12,
        title: 'iForm Termin',
        mouseOver: 'iForm Entscheidungs-Termin',
    },
    {
        id: 13,
        title: 'iForm DG-AM',
        mouseOver: 'iForm an DGAPI-AM',
    },
    {
        id: 14,
        title: 'Auftrag DL-Paket',
        mouseOver: 'Auftrag an AMS zum DL-Paket',
    },
    {
        id: 15,
        title: 'Bemerk',
        mouseOver: 'Bemerkung'
    },
]